import sIcon from '@/components/SIcon/index.vue';
import isWeChatWeb from '@/utils/checkWebUserAgent';
import plugins from '@/utils/globleComponents';
import '@/utils/rem.js';
import setInfoDecimal from '@/utils/setInfoDecimal';
import Vant, { Toast } from 'vant';
import 'vant/lib/index.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import "@/styles/basis.scss";


// const isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

// if (isIOS) {
// 	window.history.pushState({}, 'title', '#');
// }

// 版本更新 跳转
const VUE_APP_VERSION = require('../package.json').version;

const vers = window.localStorage.getItem('Version');

if (VUE_APP_VERSION !== vers) {
	store.dispatch('user/loginOut').then(() => {
		window.localStorage.setItem('Version', VUE_APP_VERSION);
		location.reload();
		this.$router.push('/login');
	});
}

// 全局添加 ¥计算函数
Vue.prototype.$setInfoDecimal = setInfoDecimal;
Vue.prototype.$toast = Toast;
// 判断是否微信浏览器
Vue.prototype.$isWeChatWeb = isWeChatWeb;

Vue.use(plugins);
Vue.use(Vant);

Vue.component('s-icon', sIcon);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
